export enum EquipmentKits {
  ThreeImpulse = "ThreeImpulse",
  TwoImpulseOneConstant = "TwoImpulseOneConstant",
  OneImpulseTwoConstant = "OneImpulseTwoConstant"
}

export const KitConfig = {
  [EquipmentKits.ThreeImpulse]: "Три імпульсних",
  [EquipmentKits.TwoImpulseOneConstant]: "Два імпульсних та один постійний",
  [EquipmentKits.OneImpulseTwoConstant]: "Один імпульсний та два постійних"
}
